import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useCookieYesConsent } from 'hooks/useCookieYesConsent';
import { COOKIEYES_CATEGORY } from 'utils/cookieYesConsent';
import {
  isMetaPixelEnabled,
  loadMetaPixel,
  setMetaPixelConsent,
  trackMetaPixelPageView,
} from 'utils/metaPixel';

const MetaPixel = () => {
  const location = useLocation();
  const accepted = useCookieYesConsent();
  const [isReady, setIsReady] = useState(false);

  const enabled = isMetaPixelEnabled();
  const consentGranted = accepted.includes(COOKIEYES_CATEGORY.advertisement);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (!isReady) {
      if (!consentGranted) {
        return;
      }

      loadMetaPixel(window.runConfig.metaPixelId as string);
      setIsReady(true);
      return;
    }

    setMetaPixelConsent(consentGranted);
  }, [enabled, isReady, consentGranted]);

  useEffect(() => {
    if (!isReady || !consentGranted) {
      return;
    }

    trackMetaPixelPageView();
  }, [isReady, consentGranted, location.pathname, location.search]);

  return null;
};

export default MetaPixel;
